// extracted by mini-css-extract-plugin
export default {"fixed":"GenerationFixedButton_fixed__gKaxb","button":"GenerationFixedButton_button__tGi8c","buttonContent":"GenerationFixedButton_buttonContent__-1tpO"};